// Data Management Wrappers, Contexts, and Providers

import { createContext } from 'react';

export const AppContext = createContext([]);

export const NavigateContext = createContext(null);

export const PFContext = createContext(null);